import React from 'react';
import { connect } from 'react-redux';
import { getActiveLanguage } from 'react-localize-redux';

import { getLocalizedString, getBrowserLocale } from '../../localization/LocalizedString';

import List from '../list/List';
import ServiceSiteListItem from './ServiceSiteListItem';

class ServiceSiteList extends React.Component {
  getServiceSiteGroups() {
    const { serviceSites = [], currentLanguage } = this.props;

    const browserLocale = getBrowserLocale(currentLanguage);

    const comparator = (a, b) => (a || '').toUpperCase().localeCompare((b || '').toUpperCase(), browserLocale);

    const groups = {};

    serviceSites.forEach((serviceSite) => {
      const group = getLocalizedString(serviceSite.group, currentLanguage) || '';

      groups[group] = groups[group] || [];
      groups[group].push({
        ...serviceSite,
        key: serviceSite.serviceSiteId,
      });
    });

    const serviceSiteGroups = [];

    for (const group of Object.keys(groups).sort(comparator)) {
      serviceSiteGroups.push({
        group,
        serviceSites: groups[group].sort((a, b) => comparator(getLocalizedString(a.name, currentLanguage), getLocalizedString(b.name, currentLanguage))),
      });
    }

    return serviceSiteGroups;
  }

  render() {
    const { additionalInfo = false } = this.props;

    const serviceSiteGroups = this.getServiceSiteGroups();

    const attrs = {
      additionalInfo,
    };

    const urlParts = window.location.href.split("/");
    const source = urlParts[urlParts.length - 1];
    return (
      <div>
        {serviceSiteGroups.map(serviceSiteGroup => (
            <List key={serviceSiteGroup.group} source={source} title={serviceSiteGroup.group} data={serviceSiteGroup.serviceSites}>
                <ServiceSiteListItem {...attrs}/>
            </List>
        ))}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentLanguage: getActiveLanguage(state.locale).code,
});

export default connect(
  mapStateToProps,
  null,
)(ServiceSiteList);



// WEBPACK FOOTER //
// ./src/components/servicesite/ServiceSiteList.js